import { render, staticRenderFns } from "./pfdformatPrint.vue?vue&type=template&id=fccd6cc6&scoped=true&"
import script from "./pfdformatPrint.vue?vue&type=script&lang=js&"
export * from "./pfdformatPrint.vue?vue&type=script&lang=js&"
import style0 from "./pfdformatPrint.vue?vue&type=style&index=0&id=fccd6cc6&lang=scss&scoped=true&"
import style1 from "./pfdformatPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd6cc6",
  null
  
)

export default component.exports